import PropTypes from 'prop-types';
import { forwardRef } from 'react';
import { twMerge } from 'tailwind-merge';

import Box from 'shopper/components/Box';
import Heading from 'shopper/components/Heading';
import Switch from 'shopper/components/Switch';

import { sendEvent } from 'lib/gtag';
import placeholder from 'lib/placeholder';
import { noop } from 'lib/utils';

import OFFER from 'constants/offer';

const FilterByVenue = forwardRef(
  (
    {
      className,
      gaEventCategory,
      venue = null,
      onOffersVenueFilterChange = noop,
    },
    ref
  ) => {
    const onNationalSwitchChange = () => {
      onOffersVenueFilterChange(OFFER.VENUES_VALUES.NATIONAL);
      sendEvent({ category: gaEventCategory, action: 'filter_offer_national' });
    };

    const onInternationalSwitchChange = () => {
      onOffersVenueFilterChange(OFFER.VENUES_VALUES.INTERNATIONAL);
      sendEvent({
        category: gaEventCategory,
        action: 'filter_offer_international',
      });
    };

    return (
      <Box
        ref={ref}
        className={twMerge(
          'flex-col p-4 md:flex-row md:items-center md:justify-end xl:flex-col xl:items-stretch xl:justify-start',
          className
        )}
        full
      >
        <Heading
          as="span"
          className="hidden md:mb-0 md:block xl:mb-4"
          size="size5"
        >
          Tipo de Oferta:
        </Heading>
        <Switch
          checked={venue === OFFER.VENUES_VALUES.NATIONAL}
          className="mb-4 md:mx-4 md:mb-0 xl:mx-0 xl:mb-4"
          data-test-selector="toggle-national-offers-filter"
          label={placeholder('switches.onlyNationalOffers')}
          onChange={onNationalSwitchChange}
        />
        <Switch
          checked={venue === OFFER.VENUES_VALUES.INTERNATIONAL}
          data-test-selector="toggle-international-offers-filter"
          label={placeholder('switches.onlyInternationalOffers')}
          onChange={onInternationalSwitchChange}
        />
      </Box>
    );
  }
);

FilterByVenue.displayName = 'FilterByVenue';

FilterByVenue.propTypes = {
  venue: PropTypes.string,
  onOffersVenueFilterChange: PropTypes.func,
};

export default FilterByVenue;
